import { useLocation } from "react-router-dom";
import { Grid } from "@financeable-com-au/financeable-ui";
import DisclosureSignature, { DisclosureParams } from "@/components/DisclosureStatement/DisclosureStatement";

export default function Disclosure() {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return (
    <Grid
      container
      xs={12}
      style={{
        padding: "30px 30px 0",
        background: "#efefef",
        minHeight: "calc(100vh - 64px)",
      }}
    >
      <Grid container xs={12} justifyContent="center">
        <Grid direction="column" xs={12} sm={12} md={10} lg={6} xl={6}>
          <DisclosureSignature params={params as unknown as DisclosureParams} />
        </Grid>
      </Grid>
    </Grid>
  );
}
